// Angular
import { Component, Input, OnInit } from '@angular/core';
// modules
import { UnifiedSample } from 'src/app/modules/samples-member/models';

@Component({
    selector: 'app-sample-detail',
    templateUrl: './sample-detail.component.html',
    styleUrls: ['./sample-detail.component.scss'],
    standalone: false
})
export class SampleDetailComponent implements OnInit {
    @Input() sample: UnifiedSample = null;

    constructor() {}

    ngOnInit(): void {}
}
